import { useState, useEffect } from 'react'
import { RecipeCardDetailed } from '@client'
import { set } from 'date-fns'
// ----------------------------------------------------------------------

export default function CustomRecommendedRecipes({ recipes }) {
  const [recommended, setRecommended] = useState([])

  useEffect(() => {
    setRecommended(recipes)
  }, [])

  return (
    <section
      id='custom-recommended-recipes'
      className='container grid grid-cols-1 gap-10 lg:grid-cols-2'
    >
      {recommended?.length > 0 &&
        recommended.map((recipe, i) => {
          return (
            <RecipeCardDetailed key={`${recipe.slug}_${i}`} recipe={recipe} />
          )
        })}
    </section>
  )
}
